export default "__VITE_ASSET__BQU_xqDZ__"